import React, { useContext, useEffect, useState } from 'react';
import brushImg from '../../../assets/images/brush.png';
import { notification, Switch } from 'antd';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';
import { ServicesContext } from '../../Reusable/ServiceContextmain';
import { Helmet } from 'react-helmet';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);
const ContactIndex = () => {
  const { services, loading, error } = useContext(ServicesContext);
  const [data, setdata] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    axiosInstance
      .get(`settings`)
      .then((res) => {
        setdata(res?.data?.settings);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const date = new Date();
  const [isTenderQuery, setIsTenderQuery] = useState(false);
  const minDateTime = date.toISOString().slice(0, 16);
  const [Loading, setLoading] = useState(false);

  const [formdata, setformdata] = useState({
    name: '',
    email: '',
    phone: '',
    datetime: '',
    servicename: '',
    message: '',
    noOfProperties: '',
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'name':
        if (!value) error = 'Name is required.';
        break;
      case 'email':
        if (!value) {
          error = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = 'Email address is invalid.';
        }
        break;
      case 'phone':
        if (!value) {
          error = 'Phone number is required.';
        } else if (!/^\d{10,15}$/.test(value)) {
          error =
            'Phone number must contain only digits and be 10-15 digits long.';
        }
        break;
      case 'datetime':
        if (!value) {
          error = 'Date and time are required.';
        } else if (dayjs(value).isBefore(dayjs())) {
          error = 'Please select a future date and time.';
        }
        break;
      case 'servicename':
        if (!value || value === 'Your-Service') {
          error = 'Please select a service.';
        }
        break;
      case 'message':
        if (!value) error = 'Message is required.';
        break;
      default:
        break;
    }
    return error;
  };

  const HandleInquiry = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    for (const field in formdata) {
      const error = validateField(field, formdata[field]);
      if (error) validationErrors[field] = error;
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      try {
        const EnquiryData = {
          ...formdata,
          tendercontract: isTenderQuery ? 1 : 0,
        };

        const response = await axiosInstance.post(`/inquiry/add`, EnquiryData);
        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-check2-circle text-success"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Enquiry Submitted Successfully</div>
              </div>
            ),
            description: 'You can expect call in 24 hours from our team.',
          });
          setLoading(false);
          setformdata({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: '',
            message: '',
            noOfProperties: '',
          });
        } else {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-exclamation-circle-fill text-danger"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: 'Try Again !',
          });
          setformdata({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: '',
            message: '',
            noOfProperties: '',
          });
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    if (name === 'phone') {
      value = value.replace(/\D/g, '');
    }
    // Update formdata first
    const updatedFormData = { ...formdata, [name]: value };
    setformdata(updatedFormData);
    // Validate the field
    const error = validateField(name, value);
    // Update errors based on validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleSwitchChange = (checked) => {
    setIsTenderQuery(checked); // Update the state based on the switch value
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  return (
    <div>
      <Helmet>
        <title>{data[2]?.metatitle || 'Precision Contract Cleaning'}</title>
        <meta
          name="description"
          content={data[2]?.metadescription || 'Precision Contract Cleaning'}
        />
        <meta
          name="keywords"
          content={data[2]?.metakeywords || 'Precision Contract Cleaning'}
        />
      </Helmet>
      {Loading && <Loader />}
      <div className="rs-contact contact-style3 pt-120 pb-120 md-pt-80 md-pb-80">
        <div className="container custom2">
          <div className="row">
            <div className="col-lg-5 md-mb-50">
              <div className="rs-contact-box">
                <div className="sec-title2 mb-40">
                  <div className="brush-content mb-20">
                    <img src={brushImg} alt="" />
                    <span className="sub-text">Contact Us</span>
                  </div>
                  <h2 className="title small pb-15">Get In Touch</h2>
                  <div className="desc">
                    We’re here to assist you with all your cleaning needs. Reach
                    out to us for inquiries, quotes, or any questions—our team
                    is ready to help!
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Visit Us:</span>
                    <span className="des">
                      4 Rivers Street, Leicester, England, LE3 5RX
                    </span>
                  </div>
                </div>
                <div className="address-item mb-30">
                  <div className="address-icon">
                    <i className="bi bi-envelope-open"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Mail Us:</span>
                    <a
                      href="mailto:info@precisioncontractservices.com"
                      className="des"
                    >
                      info@precisioncontractservices.com
                    </a>
                  </div>
                </div>
                <div className="address-item">
                  <div className="address-icon">
                    <i className="bi bi-telephone-inbound"></i>
                  </div>
                  <div className="address-content">
                    <span className="label">Phone:</span>
                    <a href="tel:01162102688" className="des d-block">
                      01162102688
                    </a>
                    <a href="tel:07380851496" className="des d-block">
                      07380851496
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 pl-50 md-pl-15">
              <div className="contact-drop-line">
                <div className="heading-inner-title mb-30">
                  <h2 className="title">Get Clean Today!</h2>
                </div>
                <div id="form-messages" />
                <form id="contact-form" onSubmit={HandleInquiry}>
                  <fieldset>
                    <div className="row">
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Name"
                          value={formdata.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.name}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="text"
                          id="email"
                          name="email"
                          placeholder="E-Mail"
                          value={formdata.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.email}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <input
                          className="from-control"
                          type="tel"
                          id="phone"
                          name="phone"
                          placeholder="Phone Number"
                          value={formdata.phone}
                          onChange={handleChange}
                          maxLength={15}
                        />
                        {errors.phone && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.phone}
                          </span>
                        )}
                      </div>
                      <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                        <DatePicker
                          showTime
                          format="DD/MM/YYYY hh:mm A"
                          placeholder="dd/mm/yyyy --:-- --"
                          disabledDate={(current) =>
                            current && current < dayjs().startOf('day')
                          }
                          style={{
                            width: '100%',
                            height: '54px',
                          }}
                          value={
                            formdata.datetime ? dayjs(formdata.datetime) : null
                          }
                          onChange={(date) => {
                            // Ignore clearing action
                            if (!date) {
                              return;
                            }

                            setformdata((prev) => ({
                              ...prev,
                              datetime: date.format('YYYY-MM-DD HH:mm:ss'),
                            }));

                            setErrors((prev) => ({
                              ...prev,
                              datetime: '',
                            }));
                          }}
                          allowClear={false}
                        />{' '}
                        {errors.datetime && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.datetime}
                          </span>
                        )}
                      </div>
                      <div className="col-12 mb-30">
                        <select
                          name="servicename"
                          className="wpcf7-form-control wpcf7-select"
                          value={formdata.servicename}
                          onChange={handleChange}
                        >
                          <option value="">Select Service</option>
                          {Array.isArray(services) &&
                            services.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </select>
                        {errors.servicename && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.servicename}
                          </span>
                        )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <h6 className="form-Query mb-3">
                          Is This Query For Tender Contract?
                        </h6>
                        <Switch
                          defaultChecked={false}
                          onChange={handleSwitchChange}
                        />
                      </div>
                      {isTenderQuery && (
                        <div className="col-12 mb-3">
                          <input
                            type="number"
                            min={1}
                            className="from-control"
                            id="noOfProperties"
                            name="noOfProperties"
                            placeholder="No. of Properties"
                            value={formdata.noOfProperties}
                            onChange={handleChange}
                          />
                        </div>
                      )}
                      <div className="col-lg-12 mb-30">
                        <textarea
                          className="from-control"
                          id="message"
                          name="message"
                          placeholder="Your Message"
                          value={formdata.message}
                          onChange={handleChange}
                        />
                        {errors.message && (
                          <span
                            className="text-danger ps-3"
                            style={{ fontSize: '14px' }}
                          >
                            * {errors.message}
                          </span>
                        )}
                      </div>

                      <div className="btn-part">
                        <div className="form-group mb-0">
                          <p className="submit-btn submit-btn3">
                            <input type="submit" defaultValue="Submit Now" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div className="map-canvas pt-120 md-pt-80">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2421.34774578151!2d-1.1501085240545226!3d52.63563012766313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487760e7cc90aaf3%3A0x4f8816c696f1712d!2s4%20Rivers%20St%2C%20Leicester%20LE3%205RX%2C%20UK!5e0!3m2!1sen!2sin!4v1727871762482!5m2!1sen!2sin"
              width={600}
              height={450}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactIndex;
